function getDefaultBackground() {
    // have to add to the document in order to use getComputedStyle
    const div = document?.createElement?.('div');
    document?.head?.appendChild?.(div);
    const bg = window?.getComputedStyle?.(div)?.backgroundColor;
    document?.head?.removeChild?.(div);
    return bg;
}

export function getParentBackgroundColor(el: HTMLElement) {
    // get default style for current browser
    const defaultStyle = getDefaultBackground?.();
    if (!el) {
        return defaultStyle;
    }

    // get computed color for el
    const backgroundColor = window?.getComputedStyle?.(el)?.backgroundColor;

    // if we got a real value, return it
    if (backgroundColor != defaultStyle) {
        return backgroundColor;
    }

    // if we've reached the top parent el without getting an explicit color, return default
    if (!el?.parentElement) {
        return defaultStyle;
    }

    // otherwise, recurse and try again on parent element
    return getParentBackgroundColor(el?.parentElement);
}
